import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./globals.css";
import "leaflet/dist/leaflet.css";

// OBS-1: Initialize global error tracking BEFORE React mounts.
// Captures load-time JS errors, unhandled promise rejections, etc.
import { errorTracker } from "./services/errorTrackingService";
errorTracker.init();

// A configuração do worker do PDF.js SAIU daqui (05/08/2026) — ver
// `./lib/pdfWorker.ts`, que segue sendo a fonte única do `workerSrc`.
//
// Estava neste arquivo para ser fonte única, intenção correta com custo alto:
// importar `react-pdf` no ENTRY punha a biblioteca inteira no grafo ansioso, e
// todo usuário baixava ~98 KB (comprimidos) de renderizador de PDF só para
// abrir a tela de login — inclusive o parceiro no celular, que na maioria das
// sessões nunca abre um PDF. Agora quem renderiza PDF importa de `lib/pdfWorker`
// e o custo é pago por quem usa.

// PWA Service Worker — Story X1.1.2 (cache shell + update prompt) sobre PRD-1
// §1.6.3 (push). Registro centralizado em sw-registration (workbox-window):
// precache do shell, fallback offline e detecção de versão nova → UpdatePrompt.
// Em dev NÃO registra (evita SW cacheando código velho durante hot reload);
// vite-plugin-pwa só emite o SW no build de produção.
import { registerServiceWorker } from "./lib/sw-registration";

if (import.meta.env.PROD) {
  window.addEventListener("load", () => {
    registerServiceWorker();
  });
}

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);

  // Sinaliza à rede de segurança do `index.html` que o boot foi até o fim, o
  // que limpa o guard de recuperação. Sem isso, o guard ficaria marcado para a
  // sessão inteira e uma falha futura — legítima — não teria como se recuperar.
  //
  // Fica DEPOIS do render de propósito: se o módulo tivesse falhado antes daqui,
  // esta linha não roda, que é exatamente o sinal que a recuperação precisa.
  window.__sewebBootOk?.();
}
